module.exports = __webpack_public_path__ + "media/localization/portuguese-1ecbb731.png";